import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment/moment';
import DepsService from 'services/dependencies';

const CONTEXT = 'retailerReports';

function formatDate(dateToFormat) {
  if (dateToFormat) {
    return moment(dateToFormat).format('YYYY-MM-DD');
  }
  return undefined;
}

export const fetchRetailerReports = async (params) => {
  const { url } = DepsService.rest.reports.entries;
  const queryParams = cloneDeep(params);
  queryParams.filters.creationDateFrom = formatDate(queryParams.filters.creationDateFrom);
  queryParams.filters.creationDateTo = formatDate(queryParams.filters.creationDateTo);
  const urlParams = {};

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadRetailerReport = ({ id, extension, ...parameters }) => {
  const { url } = DepsService.rest.reports.download;
  const queryParams = {
    'transformation-type': extension,
    ...parameters,
  };
  const urlParams = { id };

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/resources/retailer-reports.api.js